import styled from "styled-components";
import Close from "../assets/img/Cancel.svg";
import { useState } from "react";
import axios from "axios";
import Dot from "../assets/img/dot.svg";
import { useEffect } from "react";
import Modal from "./Modal";
import ApiUrl from "../config/app-config";
import Loading from "./Loading";

const baseURL = ApiUrl();

const StyledCallSelect = styled.div`
  z-index: 5;
  position: fixed;
  width: 100%;
  height: 100vh;
  &::-webkit-scrollbar {
    display: none;
  }
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(13, 13, 13, 1);
  overflow: hidden;
`;

function CallSelect({ closeModal, onCallSelect, userId }) {
  /**list 데이터 받아오기 */
  const [data, setData] = useState();
  const [commonError, setCommonError] = useState(false);
  /**로딩 */
  const [isLoading, setIsLoading] = useState(false);
  async function getData() {
    setIsLoading(true);
    try {
      //응답 성공
      const response = await axios.get(`${baseURL}/v1/call/history/${userId}`, {
        params: {
          currentPageIndex: 1,
          listSize: 50,
        },
      });
      const success = response.data;
      const result = success.result;
      setIsLoading(false);
      setData(result);
      //console.log("CallData", result);
    } catch (error) {
      //응답 실패
      setIsLoading(false);
      setCommonError(true);
      console.error(error);
    }
  }
  useEffect(() => {
    getData();
  }, []);

  const onSelect = (e) => {
    onCallSelect(e.target.value);
    closeModal();
  };
  const errorModal = () => {
    setCommonError(false);
    closeModal();
  };

  useEffect(() => {
    if (isLoading === true || commonError === true) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [isLoading, commonError]);

  return (
    <>
      <StyledCallSelect>
        <div className="header_wrap call_header">
          <div className="headers">
            <h1 className="font-header">운행 번호 선택</h1>
            <img src={Close} alt="닫기" onClick={closeModal} />
          </div>
        </div>
        {data && data.length > 0 ? (
          <div className="call_content">
            {data &&
              data.map((call) => {
                return (
                  <div className="call_select" key={call.id}>
                    <input
                      type="radio"
                      id={call.id}
                      value={call.randomCode}
                      onClick={onSelect}
                    />
                    <label htmlFor={call.id}>
                      <span className="select_header">
                        <span>{call.randomCode}</span>
                        <span className="time_wrap">
                          <span className="start_time">
                            {call.startAt.split("T")[0]}{" "}
                            {call.startAt.split("T")[1].substr(0, 5)}
                          </span>
                          <span className="mg_w">~</span>
                          <span className="start_time">
                            {call.endAt.split("T")[0]}{" "}
                            {call.endAt.split("T")[1].substr(0, 5)}
                          </span>
                        </span>
                      </span>
                      <span className="select_content">
                        <img src={Dot} alt="dot" />
                        <span className="course">
                          <span className="start_course">
                            {call.startAddress01 + " " + call.startAddress02}
                          </span>
                          <span className="end_course">
                            {call.endAddress01 + " " + call.endAddress02}
                          </span>
                        </span>
                      </span>
                      <span className="select_footer">
                        <span className="car_info">
                          <span className="call_type">콜({call.type})</span>
                          <span className="gubun">|</span>
                          <span className="car_num">
                            {call.carName} {call.carNumber}
                          </span>
                        </span>
                        <span className="car_status">{call.stateView}</span>
                      </span>
                    </label>
                  </div>
                );
              })}
          </div>
        ) : (
          <div className="no_list">
            <h5>운행 내역이 없습니다.</h5>
          </div>
        )}
      </StyledCallSelect>
      {commonError && (
        <Modal closeModal={errorModal}>
          <div className="common_error">
            <p>오류가 발생하였습니다.</p>
            <p>다시 시도하여 주십시오.</p>
          </div>
        </Modal>
      )}
      {isLoading && <Loading />}
    </>
  );
}

export default CallSelect;
